// Pause menu, opened by tapping the lap timer.

import { addTapHaptic } from '../input/haptics';

export interface MenuItem {
  id: string;
  label: () => string;
  run: () => void;
  /** Close the menu (resume) after running. */
  closes?: boolean;
}

export class PauseMenu {
  private readonly el: HTMLElement;
  private readonly list: HTMLElement;
  open = false;
  onChange: ((open: boolean) => void) | undefined;

  constructor(
    root: HTMLElement,
    private readonly items: MenuItem[],
  ) {
    this.el = document.createElement('div');
    this.el.className = 'overlay menu';
    this.el.innerHTML = `<div class="menu-title">Paused</div><div class="menu-list"></div>`;
    root.appendChild(this.el);
    this.list = this.el.querySelector('.menu-list') as HTMLElement;
    this.el.addEventListener('pointerdown', (e) => e.stopPropagation());
    for (const item of items) {
      const b = document.createElement('button');
      b.dataset['id'] = item.id;
      b.appendChild(document.createElement('span'));
      b.addEventListener('click', () => {
        item.run();
        if (item.closes) this.close();
        else this.render();
      });
      addTapHaptic(b);
      this.list.appendChild(b);
    }
  }

  private render(): void {
    for (const b of this.list.querySelectorAll('button')) {
      const item = this.items.find((i) => i.id === b.dataset['id']);
      const label = b.querySelector('span');
      if (item && label) label.textContent = item.label();
    }
  }

  show(): void {
    this.open = true;
    this.render();
    this.el.classList.add('show');
    this.onChange?.(true);
  }

  close(): void {
    this.open = false;
    this.el.classList.remove('show');
    this.onChange?.(false);
  }
}
